import React, { FC } from 'react'

import { WithDataName } from 'common/types'
import { Verified } from 'components/presentational/photoStatus/PhotoStatus'
import { VerifiedSvg } from 'components/presentational/svg/VerifiedSvg'

export const VerifiedIcon: FC<
  { className?: string; size?: number; iconUid: string } & WithDataName
> = ({ className, size, iconUid, ...rest }) => {
  const dataName = rest['data-name'] ? rest['data-name'] : 'status-verified'

  return (
    <Verified className={className} data-name={dataName}>
      <VerifiedSvg uid={iconUid} size={size} />
    </Verified>
  )
}
